export function addToken(Token){
    return{
        type: 'ADD_TOKEN',
        payload: Token
    }
}

export function removeToken(Token){
    return{
        type:'REMOVE_TOKEN',
        payload: Token
        
    }
}